import React, {useEffect, useState} from 'react';
import Input from '../Components/Input';
import Button from '../Components/Button';
import { Link } from 'react-router-dom';


import classes from '../Pages/Registration.module.css'

import SvgPatternBackground from '../Components/svgPatternBackground';

import { GoogleLogin } from '@react-oauth/google';
import jwt_decode from "jwt-decode";
import { showSignedInToast, showRegistrationSuccessToast } from '../utils/sessionToast';

function registrationEmailInUseMessage(pageContent, language) {
    const t = pageContent?.in_use_email_validation_text;
    if (t) return t;
    const lang = String(language || '').toLowerCase();
    return lang === 'de' || lang === 'deutsch'
        ? 'Diese E-Mail-Adresse wird bereits verwendet.'
        : 'This email address is already in use.';
}

export default function Registration(props) {
    const [pageContent, setPageContent] = useState({})

    const [user, setUser] = useState({
        username: "",
        name: "",
        lastname: "",
        email: "",
        pwd: "",
        picture: "https://strapi.accounting-a-z.ch/uploads/user_logo_b5b0ea4645.png",
  
    })

    const [enteredNameTouched, setEnteredNameTouched] = useState(false);
    const [enteredLastNameTouched, setEnteredLastNameTouched] = useState(false);
    const [enteredUserNameTouched, setEnteredUserNameTouched] = useState(false);
    const [enteredEmailTouched, setEnteredEmailTouched] = useState(false);
    const [enteredPwdTouched, setEnteredPwdTouched] = useState(false);

    const initError = {
        exists: false,
        helperText: null,
    };

    const [nameError, setNameError] = useState(initError);
    const [lastNameError, setLastNameError] = useState(initError);
    const [userNameError, setUserNameError] = useState(initError);
    const [usernameTakenServer, setUsernameTakenServer] = useState(false);
    const [emailTakenServer, setEmailTakenServer] = useState(false);
    const [emailError, setEmailError] = useState(initError);
    const [pwdError, setPwdError] = useState(initError);

    const [passwordCheck, setPasswordCheck] = useState("")
    const [passCheck, setPassCheck] = useState({
        longEnough: false,
        specialCharacter: false,
        number: false,
        capitalLetter: false,
        match: false
    })

    const [passwordShown, setPasswordShown] = useState(false);
    const [passwordCheckShown, setPasswordCheckShown] = useState(false);

    const [isRegistering, setIsRegistering] = useState(false);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_STRAPI_URL}api/register-page/?locale=${props.language}`, { 
            'Content-Type': 'application/json' , method: 'GET' 
            })
            .then(data => data.json())
            .then(data => {
                setPageContent(data.data.attributes)
            })
    }, [props.language])

    useEffect(() => {
        if (!user.name && enteredNameTouched) {
            setNameError({
              exists: true,
              helperText: `${pageContent.void_name_validation_text}`,
            });
        } else {
            setNameError({
              exists: false,
              helperText: null,
            });
        }
        if (!user.lastname && enteredLastNameTouched) {
            setLastNameError({
              exists: true,
              helperText: `${pageContent.void_last_name_validation_text}`,
            });
        } else {
            setLastNameError({
              exists: false,
              helperText: null,
            });
        }
        if (!user.username && enteredUserNameTouched) {
            setUserNameError({
              exists: true,
              helperText: `${pageContent.void_username_validation_text}`,
            });
            setUsernameTakenServer(false);
        } else if (!user.username) {
            setUserNameError(initError);
            setUsernameTakenServer(false);
        } else if (usernameTakenServer) {
            setUserNameError({
              exists: true,
              helperText: `${pageContent.in_use_username_validation_text}`,
            });
        } else {
            setUserNameError(initError);
        }
        
        if (!user.email && enteredEmailTouched) {
            setEmailError({
              exists: true,
              helperText: `${pageContent.void_email_validation_text}`,
            });
            setEmailTakenServer(false);
        } else if (!user.email) {
            setEmailError(initError);
            setEmailTakenServer(false);
        } else if (user.email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/) === null && user.email !== '') {
            setEmailError({
              exists: true,
              helperText: `${pageContent.valid_email_validation_text}`,
              });
        } else if (emailTakenServer) {
            setEmailError({
              exists: true,
              helperText: registrationEmailInUseMessage(pageContent, props.language),
            });
        } 
        else {
            setEmailError(initError);
        }

        if (!user.pwd && enteredPwdTouched) {
            setPwdError({
              exists: true,
              helperText: `${pageContent.void_password_validation_text}`,
            });
        } else {
            setPwdError({
              exists: false,
              helperText: null,
            });
        }

        if(user.pwd.length >= 8) {
            setPassCheck((prevState) => ({
                ...prevState,
                longEnough: true,
            }))
        } else if(user.pwd.length < 8) {
            setPassCheck((prevState) => ({
                ...prevState,
                longEnough: false,
            }))
        } 

        if (user.pwd.match(/[A-Z]/)!== null) {
            setPassCheck((prevState) => ({
                ...prevState,
                capitalLetter: true,
            }))
        } else if (user.pwd.match(/[A-Z]/)=== null) {
            setPassCheck((prevState) => ({
                ...prevState,
                capitalLetter: false,
            }))
        }

        if (user.pwd.match(/[0-9]/)!== null) {
            setPassCheck((prevState) => ({
                ...prevState,
                number: true,
            }))
        } else if (user.pwd.match(/[0-9]/)=== null) {
            setPassCheck((prevState) => ({
                ...prevState,
                number: false,
            }))
        }

        if (user.pwd.match(/[`~!@#$%\^&*()+=|;:'",.<>\/?\\\-]/)!== null) {
            setPassCheck((prevState) => ({
                ...prevState,
                specialCharacter: true,
            }))
        } else if (user.pwd.match(/[`~!@#$%\^&*()+=|;:'",.<>\/?\\\-]/)=== null) {
            setPassCheck((prevState) => ({
                ...prevState,
                specialCharacter: false,
            }))
        }

        if(user.pwd == passwordCheck && user.pwd !== "") {
            setPassCheck((prevState) => ({
                ...prevState,
                match: true,
            }))
        } else if(user.pwd != passwordCheck) {
            setPassCheck((prevState) => ({
                ...prevState,
                match: false,
            }))
        } 

        setPasswordCheck(document.getElementById("pwdCheck").value)


        
    
    }, [user, enteredNameTouched, enteredLastNameTouched, enteredUserNameTouched, enteredEmailTouched, enteredPwdTouched, passwordCheck, usernameTakenServer, emailTakenServer, pageContent, props.language])
 

    const handleChange = (evt) => {
       
        let value = evt.target.value;
        let name = evt.target.name;
        setUser((prevState) => ({
            ...prevState,
            [name]: value,  
        }))
        if (name === 'username') {
            setUsernameTakenServer(false);
        }
        if (name === 'email') {
            setEmailTakenServer(false);
        }
        if(user.pwd.length >= 7) {
            setPassCheck((prevState) => ({
                ...prevState,
                longEnough: true,
            }))
        } 

        if (user.pwd.match(/[A-Z]/) !== null) {
            setPassCheck((prevState) => ({
                ...prevState,
                capitalLetter: true,
            }))
        }

        if (user.pwd.match(/[0-9]/)!== null) {
            setPassCheck((prevState) => ({
                ...prevState,
                number: true,
            }))
        } 
        if (user.pwd.match(/[`~!@#$%\^&*()+=|;:'",.<>\/?\\\-]/)!== null) {
            setPassCheck((prevState) => ({
                ...prevState,
                specialCharacter: true,
            }))
        }
        if(user.pwd == passwordCheck && user.pwd !== "") {
            setPassCheck((prevState) => ({
                ...prevState,
                match: true,
            }))
        } 
        console.log(user.pwd, passwordCheck, user.pwd === passwordCheck)
    }

    const handleChangePassCheck = (evt) => {
        let value = evt.target.value;
        setPasswordCheck(value)
        if(user.pwd == passwordCheck && user.pwd !== "") {
            setPassCheck((prevState) => ({
                ...prevState,
                match: true,
            }))
        } 
        // console.log(user.pwd, passwordCheck, user.pwd === passwordCheck)

    }
    

    const nameIsValid = !nameError.exists && enteredNameTouched;
    const lastNameIsValid = !lastNameError.exists && enteredLastNameTouched;
    const userNameIsValid = !userNameError.exists && enteredUserNameTouched;
    const emailIsValid = !emailError.exists && enteredEmailTouched;
    const pwdIsValid = !pwdError.exists && enteredPwdTouched;

    const nameBlurHandler = (e) => {
        setEnteredNameTouched(true);
    };

    const lastNameBlurHandler = (e) => {
        setEnteredLastNameTouched(true);
    };

    const userNameBlurHandler = (e) => {
        setEnteredUserNameTouched(true);
    };

    const emailBlurHandler = (e) => {
        setEnteredEmailTouched(true);
        if (emailTakenServer) {
            setEmailError({
                exists: true,
                helperText: registrationEmailInUseMessage(pageContent, props.language),
            });
            return;
        }
        if(user.email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/) === null){
            setEmailError({
                exists: true,
                helperText: `${pageContent.valid_email_validation_text}`,
              });
        } else {
            setEmailError({
              exists: false,
              helperText: null,
            });
        }
    };

    const pwdBlurHandler = (e) => {
        setEnteredPwdTouched(true);
    };

    const handleSubmit = (evt) => {
        evt.preventDefault();

        setEnteredNameTouched(true);
        setEnteredLastNameTouched(true);
        setEnteredUserNameTouched(true);
        setEnteredEmailTouched(true);
        setEnteredPwdTouched(true);

        // Validar directamente con los valores actuales (no depender del estado asíncrono)
        let valid = true;

        if (!user.name) {
            setNameError({ exists: true, helperText: `${pageContent.void_name_validation_text}` });
            valid = false;
        }
        if (!user.lastname) {
            setLastNameError({ exists: true, helperText: `${pageContent.void_last_name_validation_text}` });
            valid = false;
        }
        if (!user.username) {
            setUserNameError({ exists: true, helperText: `${pageContent.void_username_validation_text}` });
            valid = false;
        }
        if (!user.email) {
            setEmailError({ exists: true, helperText: `${pageContent.void_email_validation_text}` });
            valid = false;
        } else if (user.email.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/) === null) {
            setEmailError({ exists: true, helperText: `${pageContent.valid_email_validation_text}` });
            valid = false;
        }

        if (!user.pwd) {
            setPwdError({ exists: true, helperText: `${pageContent.void_password_validation_text}` });
            valid = false;
        } else {
            const pwd = user.pwd;
            const longEnough      = pwd.length >= 8;
            const hasCapital      = /[A-Z]/.test(pwd);
            const hasNumber       = /[0-9]/.test(pwd);
            const hasSpecial      = /[`~!@#$%^&*()+=|;:'",.<>/?\\-]/.test(pwd);
            const doesMatch       = pwd === passwordCheck && pwd !== '';

            if (!longEnough || !hasCapital || !hasNumber || !hasSpecial || !doesMatch) {
                setPwdError({ exists: true, helperText: `${pageContent.valid_bottom_requirements_validation_text}` });
                valid = false;
            } else {
                setPwdError({ exists: false, helperText: null });
            }
        }

        if (!valid) return;

        setIsRegistering(true);

        Promise.all([
            fetch(`${process.env.REACT_APP_API_GOLANG_URL}/v1/verifyuser/${user.username}`).then(data => data.json()),
            fetch(`${process.env.REACT_APP_API_GOLANG_URL}/v1/verifyemail/${user.email}`).then(data => data.json())
        ])
            .then((rows) => {
                const pickId = (row) => {
                    if (!row || typeof row !== 'object') return '';
                    return row.ID !== undefined ? row.ID : row.id;
                };
                const uid = pickId(rows[0]);
                const eid = pickId(rows[1]);
                /* Misma convención que Profile (verifyuser): vacío = disponible */
                const userAvailable = uid === '' || uid == null;
                const emailAvailable =
                    eid === '' || eid == null || eid === 0 || eid === '0';

                if (userAvailable && emailAvailable) {
                    const requestOptions = {
                        method: "POST",
                        body: JSON.stringify(user),
                    };

                    const registerUrl =
                        props.language === 'de'
                            ? `${process.env.REACT_APP_API_GOLANG_URL}/v1/register/`
                            : `${process.env.REACT_APP_API_GOLANG_URL}/v1/registerEN/`;

                    return fetch(registerUrl, requestOptions)
                        .then(response => response.json())
                        .then(regData => {
                            if (regData.error) {
                                console.log("Error");
                                setIsRegistering(false);
                                return;
                            }
                            showRegistrationSuccessToast(props.language);
                            setTimeout(() => {
                                window.location.href = '/confirmationRegistermail';
                            }, 1800);
                        })
                        .catch(() => setIsRegistering(false));
                }
                /* Email ya registrado — NO usar "!== 0": '' !== 0 es true y bloqueaba el aviso de username */
                if (!emailAvailable) {
                    setIsRegistering(false);
                    setUsernameTakenServer(false);
                    setEmailTakenServer(true);
                    setEmailError({
                        exists: true,
                        helperText: registrationEmailInUseMessage(pageContent, props.language),
                    });
                    return;
                }
                if (!userAvailable && emailAvailable) {
                    setUsernameTakenServer(true);
                    setEmailTakenServer(false);
                    setUserNameError({
                        exists: true,
                        helperText: `${pageContent.in_use_username_validation_text}`,
                    });
                    setIsRegistering(false);
                    return;
                }
                setUsernameTakenServer(false);
                setEmailTakenServer(false);
                setIsRegistering(false);
            })
            .catch(() => setIsRegistering(false));

    };
    
    const togglePasswordVisibility = () => {
        setPasswordShown(passwordShown ? false : true);
    };

    const togglePasswordCheckVisibility = () => {
        setPasswordCheckShown(passwordCheckShown ? false : true);
    };

    return(
        <>
        <div className={classes.RegistrationContainerContainer}>
            <div className={classes.RegistrationBox}  >  
                <div style={{height:'5%', borderRadius:'16px 16px 0 0'}}>
                    <SvgPatternBackground borderRadius={'16px 16px 0 0'} scale={3} number={1} height={'4vh'} color={'cad051'} angle={-45}/>
                </div>
                <div className={classes.RegistrationContainer} >
                    <div className={classes.Registration}>
                            <div style={{display:'flex', alignItems:'center'}}>
                                <h3 style={{margin:'0'}}>
                                    {/* {
                                        props.language === "de"
                                        ?
                                        <>Anmeldeformular</>
                                        :
                                        <>Registration form</>
                                    }  */}
                                    {pageContent.form_title}
                                </h3>
                            </div>
                            <div>
                                <form style={{display:'grid', justifyContent:'center'}} onSubmit={handleSubmit}>
                                    <div >
                                        <Input 
                                            title = {"Name"}
                                            type = {"text"}
                                            name = {"name"}
                                            placeholder = {`${pageContent.name_placeholder}`}
                                            value = {user.name}
                                            handleChange = {handleChange}
                                            handleBlur={nameBlurHandler}
                                            className={nameError.exists ? "is-invalid": ""}
                                            errorDiv = {nameError.exists ? "text-danger" : "no-danger"}
                                            errorMsg = {nameError.helperText}
                                        />
                                    </div>
                                    <div >
                                        <Input 
                                            title = {"LastName"}
                                            type = {"text"}
                                            name = {"lastname"}
                                            placeholder = {`${pageContent.last_name_placeholder}`}
                                            value = {user.lastname}
                                            handleChange = {handleChange}
                                            handleBlur={lastNameBlurHandler}
                                            className={lastNameError.exists ? "is-invalid": ""}
                                            errorDiv = {lastNameError.exists ? "text-danger" : "no-danger"}
                                            errorMsg = {lastNameError.helperText}
                                        />
                                    </div>
                                    <div >
                                        <Input 
                                            title = {"UserName"}
                                            type = {"text"}
                                            name = {"username"}
                                            placeholder = {`${pageContent.username_placeholder}`}
                                            value = {user.username}
                                            handleChange = {handleChange}
                                            handleBlur={userNameBlurHandler}
                                            className={userNameError.exists ? "is-invalid": ""}
                                            errorDiv = {userNameError.exists ? "text-danger" : "no-danger"}
                                            errorMsg = {userNameError.helperText}
                                        />
                                    </div>
                                    <div >
                                        <Input 
                                            title = {"Email"}
                                            type = {"text"}
                                            name = {"email"}
                                            placeholder = {`${pageContent.email_placeholder}`}
                                            value = {user.email}
                                            handleChange = {handleChange}
                                            handleBlur={emailBlurHandler}
                                            className={emailError.exists ? "is-invalid": ""}
                                            errorDiv = {emailError.exists ? "text-danger" : "no-danger"}
                                            errorMsg = {emailError.helperText}
                                        />
                                    </div>
                                    <div style={{position:'relative', width:'235px'}}>
                                        <Input
                                            title = {"Password"}
                                            name = {"pwd"}
                                            placeholder = {`${pageContent.new_password_placeholder}`}
                                            value = {user.pwd}
                                            handleChange = {handleChange}
                                            type={passwordShown ? "text" : "password"}
                                            handleBlur={pwdBlurHandler}
                                            className={pwdError.exists ? "is-invalid": ""}
                                            errorDiv = {pwdError.exists ? "text-danger" : "no-danger"}
                                            errorMsg = {pwdError.helperText}
                                            
                                        />
                                        <i style={{position: 'absolute', top:'8px', right:'15px', cursor:'pointer'}} onClick={togglePasswordVisibility}>{passwordShown ? EyeLogo() : EyeLogoClosed()}</i>
                                    </div>
                                    <div style={{position:'relative', width:'235px'}}>
                                        <Input
                                            title = {"PasswordCheck"}
                                            type={passwordCheckShown ? "text" : "password"}
                                            name = {"pwdCheck"}
                                            id = {"pwdCheck"}
                                            placeholder = {`${pageContent.confirm_password_placeholder}`}
                                            value = {passwordCheck}
                                            handleChange = {handleChangePassCheck}
                                        />
                                        <i style={{position: 'absolute', top:'8px', right:'15px', cursor:'pointer'}} onClick={togglePasswordCheckVisibility}>{passwordCheckShown ? EyeLogo() : EyeLogoClosed()}</i>
                                    </div>
                                    <div>
                                        <div style={{fontSize:'14px', fontFamily:'sans-serif'}}>
                                            <div className={classes.RegistrationPWCheckItem} style={{display:'flex', alignItems:'center'}}>
                                                <span style={{marginRight: '10px'}}>{passCheck.longEnough ? passed() : notPassed()}</span>
                                                <p style={{color: passCheck.longEnough ? '#292929' : '#A5A5A5'}}>
                                                    {/* {
                                                        props.language === "de"
                                                        ?
                                                        <>Das Passwort besteht aus mehr als 8 Zeichen.</>
                                                        :
                                                        <>Password has more than 8 characters.</>
                                                    }  */}
                                                    {pageContent.p_requeriments_1}
                                                </p>
                                            </div>
                                            <div className={classes.RegistrationPWCheckItem} style={{display:'flex'}}>
                                                <span style={{marginRight: '10px'}}>{passCheck.capitalLetter ? passed() : notPassed()}</span>
                                                <p style={{color: passCheck.capitalLetter ? '#292929' : '#A5A5A5'}}>
                                                    {/* {
                                                        props.language === "de"
                                                        ?
                                                        <>Das Passwort hat einen Großbuchstaben.</>
                                                        :
                                                        <>Password has a capital letter.</>
                                                    }  */}
                                                    {pageContent.p_requeriments_2}
                                                </p>
                                            </div> 
                                            <div className={classes.RegistrationPWCheckItem} style={{display:'flex'}}>
                                                <span style={{marginRight: '10px'}}>{passCheck.number ? passed() : notPassed()}</span>
                                                <p style={{color: passCheck.number ? '#292929' : '#A5A5A5'}}>
                                                    {/* {
                                                        props.language === "de"
                                                        ?
                                                        <>Das Passwort hat eine Nummer.</>
                                                        :
                                                        <>Password has a number.</>
                                                    }  */}
                                                    {pageContent.p_requeriments_3}
                                                </p>
                                            </div>
                                            <div className={classes.RegistrationPWCheckItem} style={{display:'flex'}}>
                                                <span style={{marginRight: '10px'}}>{passCheck.specialCharacter ? passed() : notPassed()}</span>
                                                <p style={{color: passCheck.specialCharacter ? '#292929' : '#A5A5A5'}}>
                                                    {/* {
                                                        props.language === "de"
                                                        ?
                                                        <>Das Passwort hat ein Sonderzeichen.</>
                                                        :
                                                        <>Password has a special character.</>
                                                    }  */}
                                                    {pageContent.p_requeriments_4}
                                                </p>
                                            </div>
                                            <div className={classes.RegistrationPWCheckItem} style={{display:'flex'}}>
                                                <span style={{marginRight: '10px'}}>{passCheck.match ? passed() : notPassed()}</span>
                                                <p style={{color: passCheck.match ? '#292929' : '#A5A5A5'}}>
                                                    {/* {
                                                        props.language === "de"
                                                        ?
                                                        <>Passwörter stimmen überein.</>
                                                        :
                                                        <>Passwords match.</>
                                                    }  */}
                                                     {pageContent.p_requeriments_5}
                                                </p>
                                            </div>
                                        </div>
                                        
                                    </div>
                                            

                                    <div style={{display:'flex', justifyContent:'center', marginTop:'30px'}}>
                                        <Button
                                            title={
                                                isRegistering
                                                    ? (props.language === 'de' ? 'Bitte einen Moment…' : 'One moment please…')
                                                    : `${pageContent.register_text}`
                                            }
                                            className={"ochre"}
                                            disabled={isRegistering}
                                        />
                                    </div>
                                </form>
                            </div>

                    </div>
                    <div className={classes.DivisionLine}></div>
                    <div className={classes.RegistrationOtherOptions}>
                        <div style={{display:'grid', height:'min-content', justifyItems:'center'}}>
                            <div className='subtitle'>       
                                {/* {
                                    props.language === "de"
                                    ?
                                    <>oder registrieren Sie sich bei</>
                                    :
                                    <>or register with</>
                                }  */}
                                {pageContent.or_text}
                            </div>
                            <div
                                style={{display: 'flex', justifyContent: 'center', margin: '3rem'}}
                            >
                                <GoogleLogin
                                    onSuccess={credentialResponse => {
                                        console.log(credentialResponse);
                                        var decoded = jwt_decode(credentialResponse.credential);
                                        console.log(decoded)
                                                const requestOptions = {
                                                    method: "POST",
                                                    body: JSON.stringify({
                                                        username: '',
                                                        name: decoded.given_name,
                                                        lastname: decoded.family_name,
                                                        email: decoded.email,
                                                        pwd: '',
                                                        picture:  decoded.picture    
                                                    }),
                                                };
                                                // console.log(requestOptions)

                                                if(props.language === "de") {
                                                    fetch(`${process.env.REACT_APP_API_GOLANG_URL}/v1/googleauth/`, requestOptions)
                                                    .then(response => response.json())
                                                    .then(data => {
                                                        // console.log(data);
                                                        window.localStorage.setItem("jwt", {...data}.user.token);
                                                        window.localStorage.setItem("id", JSON.stringify(data.user.id));
                                                        showSignedInToast(props.language);
                                                        props.history.push({
                                                            pathname: "/basicDictionary/0",
                                                        })
                                                    });
                                                } else {
                                                    fetch(`${process.env.REACT_APP_API_GOLANG_URL}/v1/googleauthEN/`, requestOptions)
                                                    .then(response => response.json())
                                                    .then(data => {
                                                        // console.log(data);
                                                        window.localStorage.setItem("jwt", {...data}.user.token);
                                                        window.localStorage.setItem("id", JSON.stringify(data.user.id));
                                                        showSignedInToast(props.language);
                                                        props.history.push({
                                                            pathname: "/basicDictionary/0",
                                                        })
                                                    });
                                                }
    
                                                
                                        
                                    }}
                                />
                            </div>

                            <div style={{marginBottom:'30px'}} className='subtitle'>
                                {/* {
                                    props.language === "de"
                                    ?
                                    <>Sie haben ein Konto?</>
                                    :
                                    <>You have an account?</>
                                } */}
                                {pageContent.account_title}
                            </div>
                            <Link
                                to={`/login`}
                                className={'btn snow'}
                            >
                                {pageContent.login_button_text}
                            </Link>
                            
                        </div>
                    </div> 
                </div>
                     

            </div>
        </div>
        </>
    )

}

const notPassed = () => {
    return(
        <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1H10.5" stroke="#B66A00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        
    )
}

const passed = () => {
    return(
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 8L4 11L11 1" stroke="#B66A00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

        
    )
}

const EyeLogo = () => {
    return(
      <svg width="24" height="24" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.0125 15.75C5.94249 15.75 1.5325 12.65 0.0225 8.02997C-0.0075 7.92997 -0.0075 7.81997 0.0225 7.71997C1.5325 3.09997 5.94249 0 11.0125 0C16.0825 0 20.4925 3.09997 22.0025 7.71997C22.0325 7.81997 22.0325 7.92997 22.0025 8.02997C20.4925 12.65 16.0825 15.75 11.0125 15.75ZM1.0225 7.87C2.4425 11.99 6.43249 14.75 11.0125 14.75C15.5925 14.75 19.5825 11.99 21.0025 7.87C19.5825 3.75 15.5925 0.98999 11.0125 0.98999C6.43249 0.98999 2.4425 3.75 1.0225 7.87Z" fill="#B66A00"/>
        <path d="M11.0125 12.7999C8.30251 12.7999 6.09253 10.5899 6.09253 7.87994C6.09253 7.59994 6.31253 7.37994 6.59253 7.37994C6.87253 7.37994 7.09253 7.59994 7.09253 7.87994C7.09253 10.0399 8.85251 11.7999 11.0125 11.7999C13.1725 11.7999 14.9326 10.0399 14.9326 7.87994C14.9326 5.71994 13.1725 3.95996 11.0125 3.95996C10.7325 3.95996 10.5125 3.73996 10.5125 3.45996C10.5125 3.17996 10.7325 2.95996 11.0125 2.95996C13.7225 2.95996 15.9326 5.16994 15.9326 7.87994C15.9326 10.5899 13.7225 12.7999 11.0125 12.7999Z" fill="#B66A00"/>
      </svg>
    )
}

const EyeLogoClosed = () => {
    return(
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.0125 19.75C6.94249 19.75 2.5325 16.65 1.0225 12.03C0.9925 11.93 0.9925 11.82 1.0225 11.72C2.5325 7.09997 6.94249 4 12.0125 4C17.0825 4 21.4925 7.09997 23.0025 11.72C23.0325 11.82 23.0325 11.93 23.0025 12.03C21.4925 16.65 17.0825 19.75 12.0125 19.75ZM2.0225 11.87C3.4425 15.99 7.43249 18.75 12.0125 18.75C16.5925 18.75 20.5825 15.99 22.0025 11.87C20.5825 7.75 16.5925 4.98999 12.0125 4.98999C7.43249 4.98999 3.4425 7.75 2.0225 11.87Z" fill="#B66A00"/>
            <path d="M12.0125 16.7899C9.30251 16.7899 7.09253 14.5799 7.09253 11.8699C7.09253 11.5899 7.31253 11.3699 7.59253 11.3699C7.87253 11.3699 8.09253 11.5899 8.09253 11.8699C8.09253 14.0299 9.85251 15.7899 12.0125 15.7899C12.2925 15.7899 12.5125 16.0099 12.5125 16.2899C12.5125 16.5699 12.2925 16.7899 12.0125 16.7899Z" fill="#B66A00"/>
            <path d="M16.4225 12.3799C16.1425 12.3799 15.9225 12.1599 15.9225 11.8799C15.9225 9.71994 14.1624 7.95996 12.0024 7.95996C11.7224 7.95996 11.5024 7.73996 11.5024 7.45996C11.5024 7.17996 11.7224 6.95996 12.0024 6.95996C14.7124 6.95996 16.9225 9.16994 16.9225 11.8799C16.9225 12.1599 16.7025 12.3799 16.4225 12.3799Z" fill="#B66A00"/>
            <path d="M19.1426 19.51C19.0126 19.51 18.8826 19.46 18.7926 19.36L4.53257 5.09995C4.33257 4.89995 4.33257 4.58999 4.53257 4.38999C4.73257 4.18999 5.04259 4.18999 5.24259 4.38999L19.5025 18.65C19.7025 18.85 19.7025 19.16 19.5025 19.36C19.4025 19.46 19.2726 19.51 19.1526 19.51H19.1426Z" fill="#B66A00"/>
        </svg>
    )
}